import { tagsConstants } from "../../actions/tags/tags";
import { documentsWithSearchConstants } from "../../actions/documentsWithSearch";
const defaultStateObj = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  list: []
};

export default function tags(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? defaultStateObj : state;
  switch (type) {
  case documentsWithSearchConstants.CLEAR_TOTAL_COUNT:
    return defaultStateObj;
  case tagsConstants.GET_STANDARD_TAGS_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload.code,
          message: payload.message
        }
      },
      list: []
    };
  case tagsConstants.GET_STANDARD_TAGS_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false,
        errorInfo: {
          code: "",
          message: ""
        }
      },
      list: []
    };
  case tagsConstants.GET_STANDARD_TAGS_SUCCESS:
    let clonePayload = payload;

    // todo: controllare se questo map è superfluo nel caso in cui il BE torna JsonSchema come un oggetto e non come stringa
    clonePayload.map((el, key) => {
      clonePayload[key].jsonSchema = JSON.parse(el.jsonSchema);
      return clonePayload;
    });

    return {
      status: {
        started: false,
        error: false,
        ended: true,
        errorInfo: {
          code: "",
          message: ""
        }
      },
      list: clonePayload
    };
  default:
    return defaultState;
  }
}
